import React from 'react';
import SavedCredentialPreview from './SavedCredentialPreview';
import ProviderCredentialStepUpModal from './ProviderCredentialStepUpModal';
import { useProviderCredentialReveal } from '../../hooks/useProviderCredentialReveal';
import {
  normalizeSavedCredentialInfo,
  credInfoFromSettingsProvider,
} from '../../utils/providerCredentialDisplay';

/**
 * Masked saved-credential preview with secure FundElite step-up reveal.
 * Use on import flows, re-import modals, and settings connection cards.
 */
const ProviderSavedCredentialPanel = ({
  provider,
  credInfo: credInfoProp,
  credApiData,
  settingsProvider,
  canReveal = true,
  revealBlockedReason,
  theme,
  variant = 'dark',
  className = '',
}) => {
  const credentialReveal = useProviderCredentialReveal(provider);

  const credInfo = credInfoProp
    || (settingsProvider ? credInfoFromSettingsProvider(settingsProvider) : null)
    || normalizeSavedCredentialInfo(credApiData);

  if (!credInfo || !provider) return null;

  const previewTheme = theme || (variant === 'light' ? LIGHT_PREVIEW_THEME : undefined);

  return (
    <>
      <SavedCredentialPreview
        credInfo={credInfo}
        canReveal={canReveal}
        revealBlockedReason={revealBlockedReason}
        reveal={{
          ...credentialReveal,
          requestReveal: (field) => credentialReveal.requestReveal(field, { canReveal }),
        }}
        theme={previewTheme}
        variant={variant}
        className={className}
      />
      <ProviderCredentialStepUpModal
        isOpen={credentialReveal.stepUpOpen}
        onClose={credentialReveal.cancelStepUp}
        onSubmit={credentialReveal.handleStepUpSubmit}
        loading={Boolean(credentialReveal.revealLoading)}
        error={credentialReveal.revealError}
        theme={previewTheme}
      />
    </>
  );
};

const LIGHT_PREVIEW_THEME = {
  surface: { s2: '#f0fdf4' },
  border: { b2: '#bbf7d0' },
  text: { primary: '#14532d', secondary: '#166534', muted: '#15803d' },
};

export default ProviderSavedCredentialPanel;
